import { z } from 'zod';

export const DbUserStatus = z.enum(['active', 'inactive']);
export type DbUserStatus = z.infer<typeof DbUserStatus>;

export const DbUserLoginMethod = z.enum(['password', 'saml']);
export type DbUserLoginMethod = z.infer<typeof DbUserLoginMethod>;
